export { useWindowDimensions } from "react-native";
//# sourceMappingURL=index.js.map